import { createContext, useContext, useMemo } from 'react';
import { useFilterContext } from './FilterContext';
import { useFarmHasSubsidies } from '../utils/hooks';

export const SubsidySwitchContext = createContext({
  showSubsidySwitch: false,
  shouldShowSubsidies: false,
});

// Views wrapped in this provider will show the subsidy switch in the metrics
// header when the farm has subsidies.
//
// Use shouldShowSubsidies from this context rather than subsidiesEnabled from
// FilterContext when determining whether subsidies should be or will be applied.
// shouldShowSubsidies is a derived value from subsidiesEnabled that is only true
// when all of the conditons are met to show subsides. subsidiesEnabled is scoped
// to the app and can be true even when subsidies are not relevant.
export const SubsidySwitchContextProvider = ({ children }) => {
  const farmHasSubsidies = useFarmHasSubsidies();
  const { subsidiesEnabled } = useFilterContext().state;

  const value = useMemo(
    () => ({
      showSubsidySwitch: farmHasSubsidies,
      shouldShowSubsidies: subsidiesEnabled && farmHasSubsidies,
    }),
    [farmHasSubsidies, subsidiesEnabled],
  );

  return (
    <SubsidySwitchContext.Provider value={value}>
      {children}
    </SubsidySwitchContext.Provider>
  );
};

export const useSubsidySwitchContext = () => useContext(SubsidySwitchContext);
